import { render, staticRenderFns } from "./text-element.vue?vue&type=template&id=f0512e5e&scoped=true&"
import script from "./text-element.vue?vue&type=script&lang=js&"
export * from "./text-element.vue?vue&type=script&lang=js&"
import style0 from "./text-element.vue?vue&type=style&index=0&id=f0512e5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0512e5e",
  null
  
)

export default component.exports